import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom'
import { Storage } from "../../Storage/Storage"
import authServices from '../../Services/authServices';

export const Login = () => {

    const [loginError, setError] = useState('')
    const history = useHistory()

    const formik = useFormik({
        initialValues: {
            admin_email: '',
            admin_password: '',
            admin_type: 'SUPERADMIN',
        },
        validationSchema: Yup.object({
            admin_password: Yup.string()
                .min(6, 'Must be 6 characters or more')
                .required('Required'),
            admin_email: Yup.string().email('Invalid email address').required('Required'),
            admin_type: Yup.string().required('Required'),
        }),

        onSubmit: (values) => {
            let postData = {
                ...values,
                admin_email: values.admin_email.toLowerCase(),
                // admin_type: 'SUPERADMIN'
            }
            authServices.login(postData).then(res => {
                if (res.status) {
                    localStorage.setItem("user_type", res.data.admin_type ? res.data.admin_type : res.data.role)
                    localStorage.setItem("emp_name", res.data.employee_name ? res.data.employee_name : "")
                    Storage.set('auth', res.data)
                    // history.push('/admin')
                } else {
                    setError(res.message)
                }
            })
        },
    });

    const onClickForgot = () => {
        history.push('/forget-password')
        // formik.setFieldTouched('admin_email')
        // if(!Boolean(formik.errors.admin_email)){
        // }
    }
    return (
        <div className="authentication-bg">
            {/* <div className="home-btn d-none d-sm-block">
                <a href="index.html" className="text-dark"><i className="mdi mdi-home-variant h2" /></a>
            </div> */}
            <div className="account-pages w-100 pt-sm-5">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">
                                <div className="row">
                                    <div className="col-lg-12 mt-4">
                                        <div className="text-center">
                                            <a href="/admin" className="d-block auth-logo">
                                                <img src="/admin/assets/images/logo_dark.png" alt="" height={70} className="logo logo-dark" />
                                                <img src="/admin/assets/images/logo_dark.png" alt="" height={45} className="logo logo-light" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="text-center">
                                        <h5 className="text-primary">Welcome </h5>
                                        <p className="text-muted">Sign in to continue to World2Door.</p>
                                    </div>
                                    <div className="p-2 mt-4">
                                        <form onSubmit={(e) => formik.handleSubmit(e)}>
                                        <div className="form-check form-check-inline mb-2">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                id="admin"
                                                checked={formik.values.admin_type==="SUPERADMIN"}
                                                onChange={(e)=>formik.setFieldValue("admin_type","SUPERADMIN")}
                                            />
                                            <label className="form-check-label" htmlFor="admin">
                                                Admin
                                            </label>
                                            </div> 
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                id="employee"
                                                checked={formik.values.admin_type==="EMPLOYEE"}
                                                onChange={(e)=>formik.setFieldValue("admin_type","EMPLOYEE")}
                                            />
                                            <label className="form-check-label" htmlFor="employee">
                                                Employee
                                            </label>
                                            </div> 
                                            <div className="mb-3">
                                                <label className="form-label" >Email Address</label>
                                                <input
                                                    className={'form-control' + (formik.touched.admin_email ? !formik.errors.admin_email ? ' is-valid' : ' is-invalid' : '')}
                                                    type="email"
                                                    {...formik.getFieldProps('admin_email')}
                                                    placeholder="Enter email"
                                                />
                                                {formik.touched.admin_email && formik.errors.admin_email ? (
                                                    <div className="text-danger">{formik.errors.admin_email}</div>
                                                ) : null}
                                            </div>
                                            <div className="mb-3">
                                                <div className="float-end">
                                                    {/* <a onClick={() => history.push('/reset-password')} className="text-muted pointer">Forgot password?</a> */}
                                                </div>
                                                <label className="form-label" htmlFor="userpassword">Password</label>
                                                <input
                                                    className={'form-control' + (formik.touched.admin_password ? !formik.errors.admin_password ? ' is-valid' : ' is-invalid' : '')}
                                                    type="password" {...formik.getFieldProps('admin_password')}
                                                    placeholder="Enter password"
                                                />
                                                {formik.touched.admin_password && formik.errors.admin_password ? (
                                                    <div className="text-danger">{formik.errors.admin_password}</div>
                                                ) : null}
                                            </div>
                                            {/* <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="auth-remember-check" />
                                                <label className="form-check-label" htmlFor="auth-remember-check">Remember me</label>
                                            </div> */}
                                            <div className="mt-4">
                                                <p className="mb-0"><a onClick={() => onClickForgot()} className="fw-medium text-primary pointer"> Forgot Password </a> </p>
                                            </div>
                                            <div className="text-danger w-100 text-center mt-1">
                                                {loginError}
                                            </div>
                                            <div className="mt-3 text-end">
                                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                                    type="submit"
                                                // onClick={()=>Storage.set('auth' ,true)}
                                                >Log In</button>
                                            </div>
                                            <div className="mt-4 text-center">
                                                {/* <div className="signin-other-title">
                                                    <h5 className="font-size-14 mb-3 title">Sign in with</h5>
                                                </div>
                                                <ul className="list-inline">
                                                    <li className="list-inline-item">
                                                        <a href="javascript:void()" className="social-list-item bg-primary text-white border-primary">
                                                            <i className="mdi mdi-facebook" />
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <a href="javascript:void()" className="social-list-item bg-info text-white border-info">
                                                            <i className="mdi mdi-twitter" />
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <a href="javascript:void()" className="social-list-item bg-danger text-white border-danger">
                                                            <i className="mdi mdi-google" />
                                                        </a>
                                                    </li>
                                                </ul> */}
                                            </div>
                                            {/* <div className="mt-4 text-center">
                                                <p className="mb-0">Don't have an account ? <a onClick={() => history.push('/register')} className="fw-medium text-primary pointer"> Signup now </a> </p>
                                            </div> */}
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 text-center">
                                {/* <p>©  Minible. Crafted with <i className="mdi mdi-heart text-danger" /> by Themesbrand</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}